import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetLastMachinePredictedStatusResData } from "./GetLastMachinePredictedStatusResData";

const ENDPOINT = "/predictive_maintenance/status/last"

export class GetLastMachinePredictedStatusCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetLastMachinePredictedStatusReqData = null;

    constructor(params: GetLastMachinePredictedStatusReqData) {
        super();
        this.params = Object.assign({}, params);
    }

    public async execute(): Promise<GetLastMachinePredictedStatusResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetLastMachinePredictedStatusResData(res);
    }
}

export class GetLastMachinePredictedStatusReqData {
    // FilterInstallations
    installationName: string = null;
    serialNumber: string = null;
    nDays: number = null;
    dateEnd: Date = null;

    constructor(installationName: string, serialNumber: string, nDays: number, dateEnd: Date) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.nDays = nDays;
        this.dateEnd = dateEnd;
    }
}
